import { addressToScriptHash, common, ScriptBuilder, } from '@neo-one/client-common';
import sp from 'synchronized-promise';
const getInvokeMethodInvocationScript = ({ method, params, }) => {
    const sb = new ScriptBuilder();
    sb.emitAppCallInvocation(method, ...params);
    return sb.build();
};
const getInvokeMethodScript = ({ address, method, params, }) => {
    const sb = new ScriptBuilder();
    sb.emitAppCall(common.stringToUInt160(addressToScriptHash(address)), method, ...params);
    return sb.build();
};
export const addLocalKeysSync = (wallets, keyStore) => sp(async () => Promise.all(wallets.map((wallet) => keyStore.addUserAccount(wallet))))();
export const clientUtils = {
    getInvokeMethodInvocationScript,
    getInvokeMethodScript,
};

//# sourceMappingURL=clientUtils.js.map
